import { ArticleInList, type Props as ArticleInListProps } from '@/components/frontend/Layouts/ArticleInList'
import { ArticleWithImage, type Props as ArticleWithImageProps } from '@/components/frontend/Layouts/ArticleWithImage'
import { Post } from '@/payload-types'
import { Locale } from '@/providers/Locale/types'

export type PartialPost = Pick<Post, 'title' | 'slug' | 'meta' | 'heroImage' | 'publishedAt' | 'updatedAt' | 'id'>

export const emptyPost = {
    id: '',
    content: { root: { type: 'string', children: [], direction: null, format: '' as const, indent: 0, version: 0 } },
    publishedAt: new Date().toISOString(),
    updatedAt: '',
    createdAt: '',
    title: 'Placeholder Article',
    slug: 'none',
    heroImage:
        'https://images.unsplash.com/photo-1664735246075-8c8d15beb9e1?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    meta: {
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
    },
} satisfies Partial<Post>

export function getPostArray(defaultCapacity: number, posts?: Array<string | PartialPost>) {
    if (!posts || posts.length === 0) {
        return Array.from({ length: defaultCapacity }).map((_, i) => ({
            ...emptyPost,
            title: `${emptyPost.title} ${i + 1}`,
            slug: `${emptyPost.title}-${i + 1}`,
        }))
    }

    return posts.slice(0, defaultCapacity)
}

interface PostData {
    locale: Locale
    section: string
    post: PartialPost | string | undefined
}

export function postToArticle({ section, post, locale }: PostData, options: Partial<Omit<ArticleWithImageProps, 'title' | 'description' | 'postUrl'>>) {
    if (!post || typeof post === 'string') {
        return null
    }

    return (
        <ArticleWithImage
            key={`${section}-${post.slug}`}
            {...options}
            post={post}
            media={{
                media: post.heroImage,
                options: options.media?.options,
            }}
            locale={locale}
        />
    )
}

export function postToArticleList({ section, post, locale }: PostData, options: Partial<Omit<ArticleInListProps, 'title' | 'description' | 'postUrl'>> = {}) {
    if (!post || typeof post === 'string') {
        return null
    }

    return (
        <ArticleInList
            key={`${section}-${post.slug}`}
            post={post}
            {...options}
            media={{
                media: post.heroImage,
                options: options.media?.options,
            }}
            locale={locale}
        />
    )
}
